<template>
    <div>
        <div v-if="!user">Loading...</div>
        <div v-else>
            <div class="content">
                <div class="row">
                    <div class="col-md-8 col-xl-8">
                        <a
                            class="block block-link-shadow"
                            href="javascript:void(0)"
                        >
                            <div
                                class="block-content block-content-full clearfix"
                            >
                                <div class="float-left">
                                    <img
                                        class="img-avatar img-avatar128"
                                        :src="
                                            user.avatar
                                                ? `/avatar/${user.avatar}`
                                                : '/media/avatars/avatar9.jpg'
                                        "
                                    />
                                    <div class="mt-5 text-center">
                                        <button
                                            type="button"
                                            @click.prevent="showIDCard"
                                        >
                                            View ID Card
                                        </button>
                                    </div>
                                </div>
                                <div class="text-right float-right mt-10">
                                    <div class="font-w600 mb-5 text-danger">
                                        <a
                                            v-if="user.isActive == 0"
                                            class="badge badge-danger"
                                            href="javascript:void(0)"
                                            >Account Inactive</a
                                        >
                                        <a
                                            v-else
                                            class="badge badge-success"
                                            href="javascript:void(0)"
                                            >Account Active</a
                                        >
                                    </div>
                                    <div class="font-w600 mb-5 text-danger">
                                        <a
                                            v-if="user.txn_ban == 0"
                                            class="badge badge-success"
                                            href="javascript:void(0)"
                                            >Transaction Enabled</a
                                        >
                                        <a
                                            v-else
                                            class="badge badge-danger"
                                            href="javascript:void(0)"
                                            >Transaction Disabled</a
                                        >
                                    </div>
                                    <div class="font-w600 mb-5 text-danger">
                                        <a
                                            v-if="user.ban == 0"
                                            class="badge badge-success"
                                            href="javascript:void(0)"
                                            >Not Banned</a
                                        >
                                        <a
                                            v-else
                                            class="badge badge-danger"
                                            href="javascript:void(0)"
                                            >Banned</a
                                        >
                                    </div>
                                    <div class="font-size-sm text-muted">
                                        Joined: {{ user.joined }}
                                    </div>
                                    <div class="row mt-10">
                                        <button
                                            class="btn btn-sm mr-2"
                                            @click.prevent="updateAccountStatus"
                                        >
                                            {{
                                                user.isActive
                                                    ? "Deactivate Account"
                                                    : "Activate Account"
                                            }}
                                        </button>
                                        <button
                                            class="btn btn-sm mr-2"
                                            @click.prevent="
                                                updateTransactionStatus
                                            "
                                        >
                                            {{
                                                user.txn_ban
                                                    ? "Enable Transaction"
                                                    : "Disable Transaction"
                                            }}
                                        </button>
                                        <button
                                            class="btn btn-sm"
                                            @click.prevent="updateBanStatus"
                                        >
                                            {{
                                                user.ban
                                                    ? "UnBan Account"
                                                    : "Ban Account"
                                            }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-4"></div>
                </div>

                <div class="mt-3">
                    <div>
                        <!-- tab content navigation -->
                        <div class="row align-items-center">
                            <div class="col">
                                <ul
                                    class="nav nav-tabs nav-tabs-alt js-tabs-enabled"
                                    role="tablist"
                                >
                                    <li class="nav-item">
                                        <a
                                            class="nav-link active"
                                            id="personal-tab"
                                            data-toggle="tab"
                                            href="#personal"
                                            role="tab"
                                            aria-controls="personal"
                                            aria-selected="true"
                                            >Personal Info</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            id="account-tab"
                                            data-toggle="tab"
                                            href="#account"
                                            role="tab"
                                            aria-controls="account"
                                            aria-selected="false"
                                            >Account Info</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            id="transactions-tab"
                                            data-toggle="tab"
                                            href="#transactions"
                                            role="tab"
                                            aria-controls="transactions"
                                            aria-selected="false"
                                            >Transactions</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- end of tab content navigation -->
                        <!-- tab content  -->
                        <div class="tab-content" id="myTabContent">
                            <div
                                class="tab-pane fade show active"
                                id="personal"
                                role="tabpanel"
                                aria-labelledby="personal-tab"
                            >
                                <personal-component
                                    :user="user"
                                    @refresh="fetchUser"
                                />
                            </div>
                            <div
                                class="tab-pane fade"
                                id="account"
                                role="tabpanel"
                                aria-labelledby="account-tab"
                            >
                                <div class="row py-10">
                                    <div class="col-6">
                                        <button
                                            class="btn btn-sm btn-danger"
                                            @click.prevent="updateBalancesModal"
                                        >
                                            Update Balance
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-xl-3">
                                        <a
                                            class="block block-link-shadow text-right"
                                            href="javascript:void(0)"
                                        >
                                            <div
                                                class="block-content block-content-full clearfix"
                                            >
                                                <div
                                                    class="float-left mt-10 d-none d-sm-block"
                                                ></div>
                                                <div
                                                    class="font-size-h3 font-w600"
                                                >
                                                    {{ user.curr_symbol
                                                    }}<span
                                                        data-toggle="countTo"
                                                        data-speed="1000"
                                                        data-to="780"
                                                        >{{
                                                            user.accounts
                                                                .balance
                                                        }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="font-size-sm font-w600 text-uppercase text-muted"
                                                >
                                                    Account Balance
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-xl-3">
                                        <a
                                            class="block block-link-shadow text-right"
                                            href="javascript:void(0)"
                                        >
                                            <div
                                                class="block-content block-content-full clearfix"
                                            >
                                                <div
                                                    class="float-left mt-10 d-none d-sm-block"
                                                ></div>
                                                <div
                                                    class="font-size-h3 font-w600"
                                                >
                                                    {{ user.curr_symbol
                                                    }}<span
                                                        data-toggle="countTo"
                                                        data-speed="1000"
                                                        data-to="780"
                                                        >{{
                                                            user.accounts
                                                                .checking
                                                        }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="font-size-sm font-w600 text-uppercase text-muted"
                                                >
                                                    Checking Balance
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-xl-3">
                                        <a
                                            class="block block-link-shadow text-right"
                                            href="javascript:void(0)"
                                        >
                                            <div
                                                class="block-content block-content-full clearfix"
                                            >
                                                <div
                                                    class="float-left mt-10 d-none d-sm-block"
                                                ></div>
                                                <div
                                                    class="font-size-h3 font-w600"
                                                >
                                                    {{ user.curr_symbol
                                                    }}<span
                                                        data-toggle="countTo"
                                                        data-speed="1000"
                                                        data-to="780"
                                                        >{{
                                                            user.accounts
                                                                .mortgage
                                                        }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="font-size-sm font-w600 text-uppercase text-muted"
                                                >
                                                    Mortgage Balance
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-xl-3">
                                        <a
                                            class="block block-link-shadow text-right"
                                            href="javascript:void(0)"
                                        >
                                            <div
                                                class="block-content block-content-full clearfix"
                                            >
                                                <div
                                                    class="float-left mt-10 d-none d-sm-block"
                                                ></div>
                                                <div
                                                    class="font-size-h3 font-w600"
                                                >
                                                    {{ user.curr_symbol
                                                    }}<span
                                                        data-toggle="countTo"
                                                        data-speed="1000"
                                                        data-to="780"
                                                        >{{
                                                            user.accounts.card
                                                        }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="font-size-sm font-w600 text-uppercase text-muted"
                                                >
                                                    Card Balance
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="transactions"
                                role="tabpanel"
                                aria-labelledby="transactions-tab"
                            >
                                <div class="py-10">
                                    <transactions-component
                                        :user="user"
                                        @refresh="fetchUser"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- balances modal  -->
            <div
                class="modal fade"
                id="modal-balances"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-fadein"
                style="display: none;"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="card-title">Update Balance</h3>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- Beginning of the form -->
                        <form @submit.prevent="updateBalance">
                            <div class="modal-body">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="form-group">
                                            <label for="name"
                                                >Select type</label
                                            >
                                            <select
                                                type="text"
                                                class="form-control"
                                                v-model="type"
                                                required
                                            >
                                                <option value selected disabled
                                                    >Select Transaction
                                                    Type</option
                                                >
                                                <option value="1"
                                                    >Credit Account</option
                                                >
                                                <option value="0"
                                                    >Debit Account</option
                                                >
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="name"
                                                >Select Account</label
                                            >
                                            <select
                                                type="text"
                                                class="form-control"
                                                v-model="account"
                                                required
                                            >
                                                <option value selected disabled
                                                    >--- Select Account
                                                    ---</option
                                                >
                                                <option value="balance"
                                                    >Account Balance</option
                                                >
                                                <option value="checking"
                                                    >Checking Balance</option
                                                >
                                                <option value="mortgage"
                                                    >Mortgage Balance</option
                                                >

                                                <option value="card"
                                                    >Card Balance</option
                                                >
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="name">Amount</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="amount"
                                                required
                                            />
                                        </div>

                                        <div class="form-group row">
                                            <div
                                                v-if="processing"
                                                class="col-6 col-md-3"
                                            >
                                                <i
                                                    class="fa fa-2x fa-cog fa-spin text-primary"
                                                ></i>
                                            </div>
                                            <div class="col-md-9" v-else>
                                                <button
                                                    type="submit"
                                                    class="btn btn-lg btn-outline-info mb-2"
                                                >
                                                    Update Balance
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- balances modal ends  -->
        </div>
    </div>
</template>
<script>
import PersonalComponent from "../../../components/Personal";
import TransactionsComponent from "../../../components/Transactions";
import { RepositoryFactory } from "../../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");

export default {
    components: {
        PersonalComponent,
        TransactionsComponent
    },
    data() {
        return {
            user: undefined,
            processing: false,
            image_url: "",
            avatar: "",
            file: "",
            amount: 0,
            currency: 8,
            type: 1,
            account: "balance"
        };
    },
    methods: {
        async updateBalance() {
            try {
                this.processing = true;
                var data = {
                    type: this.type,
                    amount: this.amount,
                    account: this.account
                };
                await UsersRepository.updateBalance(this.user.id, data);
                this.processing = false;
                this.fetchUser();
                toast.fire({
                    type: "success",
                    title: `${this.account} balance updated successfully`
                });
                $("#modal-balances").modal("hide");
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
                this.processing = false;
            }
        },
        updateBalancesModal() {
            $("#modal-balances").modal("show");
        },
        async updateAccountStatus() {
            try {
                await UsersRepository.updateAccountStatus(this.user.id);
                this.fetchUser();
                toast.fire({
                    type: "success",
                    title: "Account status updated"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async updateTransactionStatus() {
            try {
                await UsersRepository.updateTransactionStatus(this.user.id);
                this.fetchUser();
                toast.fire({
                    type: "success",
                    title: "Transfer status updated"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async updateBanStatus() {
            await UsersRepository.updateBanStatus(this.user.id);
            this.fetchUser();
            try {
                toast.fire({
                    type: "success",
                    title: "Ban status updated"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        showIDCard() {
            $("#modal-identity").modal("show");
        },
        async fetchUser() {
            var id = this.$route.params.id;
            var res = await UsersRepository.fetchUser(id);
            this.user = res.data;
        }
    },
    created() {
        this.fetchUser();
    }
};
</script>
